import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Paper,
  Typography,
} from "@material-ui/core";
import { useLocation } from "react-router-dom";
import moment from "moment";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveIcon from "@material-ui/icons/HighlightOff";
import CheckIcon from "@material-ui/icons/CheckCircleOutline";
import { connect } from "react-redux";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Autocomplete, Timeline } from "@material-ui/lab";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import {
  AutocompleteValidator,
  DatePickerValidator,
} from "../../../../utilities/validators";
import {
  addCaseRequest,
  getCasePrioritiesRequest,
  getCaseStatusForDoctorRequest,
  getCaseStatusRequest,
  getDoctorsOfDeptRequest,
  getSignedUrlRequest,
  uploadToS3Request,
  getAllSymptomsRequest,
} from "../../CasesApiAction";
import { getUserInfo } from "../../../../utilities/storage";
import { useStyles } from "./styles";
import FolderRoundedIcon from "@material-ui/icons/FolderRounded";
import NoteForm from "../NoteForm/NoteForm";
import NoteTimeline from "../CaseForm/components/NoteItem/NoteItem";

const AddCaseDialog = ({
  openCreateCaseModal,
  setOpenCreateCaseModal,
  selectedDept,
  selectedPatient,
  setSelectedCase,
  getCasePriorities,
  casePriorities,
  getCaseStatus,
  getCaseStatusForDoctor,
  caseStatus,
  getDoctorsOfDept,
  doctors,
  addCase,
  getSignedUrl,
  uploadToS3,
  selectedDoc,
  symptomsList,
  getAllSymptoms,
}) => {
  const classes = useStyles();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const [status, setStatus] = useState(null);
  const [injuryDate, setInjuryDate] = useState(null);
  const [onSetDate, setOnSetDate] = useState(null);
  const [firstSeenDate, setFirstSeenDate] = useState(null);
  const [description, setDescription] = useState("");
  const [caseUrgency, setCaseUrgency] = useState(null);
  const [selectedSymptoms, setSelectedSymptoms] = useState([]);

  const [selectedDoctors, setSelectedDoctors] = useState([]);
  const [fixedDoctor, setFixedDoctor] = useState();
  const [showNoteBox, setShowNoteBox] = useState(false);
  const [noteImages, setNoteImages] = useState([]);
  const [note, setNote] = useState("");
  const [noteItems, setNoteItems] = useState([]);
  const [showNoteErrorMessage, setShowNoteErrorMessage] = useState("");
  const [openMedicalUpload, setOpenMedicalUpload] = useState(false);

  useEffect(() => {
    if (doctors && selectedDoc) {
      const loggedInDoctor = doctors.rows.filter(
        (doctor) => doctor.userId === selectedDoc.userId
      );
      if (loggedInDoctor.length) {
        setFixedDoctor(loggedInDoctor[0]);
        setSelectedDoctors([loggedInDoctor[0]]);
      }
    }
  }, [doctors, selectedDoc]);

  useEffect(() => {
    getCasePriorities().then((res) => {});
  }, [getCasePriorities]);

  useEffect(() => {
    getCaseStatusForDoctor().then((res) => {});
  }, [getCaseStatusForDoctor, selectedDept]);

  useEffect(() => {
    if (selectedDept) {
      getDoctorsOfDept(selectedDept.id).then((res) => {});
    }
  }, [getDoctorsOfDept, selectedDept]);

  useEffect(() => {
    getAllSymptoms();
  }, []);

  /**
   * function to handle closing of note form box
   */
  const handleNoteBoxClose = () => {
    setShowNoteBox(false);
    setNote("");
    setNoteImages([]);
    setShowNoteErrorMessage("");
  };

  /**
   * function to handle add note
   */
  const handleNotes = () => {
    if (noteImages.length === 0 && note.length === 0) {
      setShowNoteErrorMessage(
        "Please enter note or select image or medical image"
      );
    }

    if (note.length !== 0 || noteImages.length !== 0) {
      const data = {
        noteText: note,
        noteImages: noteImages,
        mediaUrls: [],
      };

      noteImages.forEach((image) => {
        const imageData = {
          fileName: image.file.name,
          fileType: `.${image.file.name.split(".").pop()}`,
        };

        getSignedUrl(imageData).then((res) => {
          uploadToS3(res.urls, image.file).then(() => {
            data.mediaUrls.push(res.path);
          });
        });
      });

      setNoteItems((noteItems) => [data, ...noteItems]);
      setShowNoteBox(false);
      setNoteImages([]);
      setNote("");
    }
  };

  /**
   * function to add case
   * @param e: event object
   */
  const onAdd = (e) => {
    e.preventDefault();

    const doctorIds = [];
    selectedDoctors.map((doctor) => doctorIds.push(doctor.userId));
    const logItems = [];
    noteItems.map((item) =>
      logItems.push({
        text: item.noteText,
        mediaUrls: item.mediaUrls,
        mediaId: item.mediaId,
      })
    );

    const data = {
      priority: caseUrgency.id,
      teamId: selectedDept.id,
      patientId: selectedPatient.id,
      desc: description,
      status: status?.id,
      date: moment(injuryDate).format("MM-DD-YYYY"),
      onSetDate: onSetDate ? moment(onSetDate).format("MM-DD-YYYY") : null,
      firstSeenDate: firstSeenDate
        ? moment(firstSeenDate).format("MM-DD-YYYY")
        : null,
      caregiver: doctorIds,
      logItem: logItems,
      symptoms: selectedSymptoms,
    };
    delete data["date"];
    delete data["onSetDate"];
    delete data["firstSeenDate"];

    addCase(data).then((res) => {
      handleClose();
      setSelectedCase(res);
    });
  };

  /**
   * function to render doctor chip
   * @param props: doctor details
   * @returns {JSX.Element}
   * @constructor
   */
  const DoctorChip = (props) => (
    <Chip avatar={<Avatar alt="profile" src={props.url} />} {...props} />
  );

  const handleClose = () => {
    setOpenCreateCaseModal(false);
    setShowNoteBox(false);
    setNote("");
    setNoteImages([]);
    setShowNoteErrorMessage("");
    setStatus(null);
    setDescription("");
    setSelectedSymptoms([]);
    setOnSetDate(null);
    setFirstSeenDate(null);
    setCaseUrgency(null);
    setSelectedDoctors([]);
  };
  return (
    <Dialog
      maxWidth="md"
      fullWidth
      open={openCreateCaseModal}
      onClose={handleClose}
      classes={{ paper: classes.dialogPaper }}
    >
      <Box className={classes.dialogHeader}>
        <Box className={classes.dialogHeaderIcon}>
          <FolderRoundedIcon style={{ fontSize: 22 }} />
        </Box>
        <Typography className={classes.dialogTitleText}>Add New Case</Typography>
      </Box>

      <ValidatorForm onSubmit={onAdd}>
        <DialogContent classes={{ root: classes.dialogContentContainer }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <AutocompleteValidator
                fullWidth
                size="small"
                options={caseStatus}
                getOptionSelected={(option, value) => option.id === value.id}
                getOptionLabel={(option) => {
                  return (
                    option.description.charAt(0).toUpperCase() +
                    option.description.slice(1)
                  );
                }}
                renderInput={(params) => (
                  <TextValidator
                    {...params}
                    label="Status"
                    variant="outlined"
                  />
                )}
                value={status}
                onChange={(e, value) => setStatus(value)}
              />
            </Grid>

            {/* <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePickerValidator
                                    fullWidth
                                    label='Injury Date *'
                                    inputVariant='outlined'
                                    size='small'
                                    format='MM/dd/yyyy'
                                    maxDate={new Date()}
                                    value={injuryDate}
                                    onChange={date => setInjuryDate(date)}
                                    validators={['required']}
                                    errorMessages={['Injury Date is required']}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid> */}

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePickerValidator
                  fullWidth
                  label="Onset Date"
                  inputVariant="outlined"
                  size="small"
                  format="MM/dd/yyyy"
                  maxDate={new Date()}
                  value={onSetDate}
                  onChange={(date) => setOnSetDate(date)}
                />
              </MuiPickersUtilsProvider>
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePickerValidator
                  fullWidth
                  label="First Seen Date"
                  inputVariant="outlined"
                  size="small"
                  format="MM/dd/yyyy"
                  maxDate={new Date()}
                  value={firstSeenDate}
                  onChange={(date) => setFirstSeenDate(date)}
                />
              </MuiPickersUtilsProvider>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <AutocompleteValidator
                fullWidth
                size="small"
                options={casePriorities}
                getOptionSelected={(option, value) => option.id === value.id}
                getOptionLabel={(option) => {
                  return (
                    option.description.charAt(0).toUpperCase() +
                    option.description.slice(1)
                  );
                }}
                renderInput={(params) => (
                  <TextValidator
                    {...params}
                    label="Urgency *"
                    variant="outlined"
                  />
                )}
                value={caseUrgency}
                onChange={(e, value) => setCaseUrgency(value)}
                validators={["required"]}
                errorMessages={["Case urgency is required"]}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <AutocompleteValidator
                multiple
                fullWidth
                size="small"
                options={symptomsList}
                getOptionLabel={(option) => option}
                value={selectedSymptoms}
                onChange={(e, value) => setSelectedSymptoms(value)}
                renderInput={(params) => (
                  <TextValidator
                    {...params}
                    variant="outlined"
                    label="Symptoms"
                    placeholder="Select symptoms"
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Autocomplete
                fullWidth
                size="small"
                multiple
                options={doctors ? doctors.rows : []}
                value={selectedDoctors} // Ensure this contains `selectedDoc`
                filterSelectedOptions
                onChange={(e, value) => {
                  const fixedDoctorsArray = Array.isArray(fixedDoctor)
                    ? fixedDoctor
                    : [];

                  setSelectedDoctors([
                    ...fixedDoctorsArray,
                    ...value.filter(
                      (option) =>
                        !fixedDoctorsArray.some(
                          (doc) => doc.userId === option.userId
                        )
                    ),
                  ]);
                }}
                getOptionLabel={(option) =>
                  `${option.firstName} ${option.lastName}`
                }
                getOptionSelected={(option, value) =>
                  option.userId === value.userId
                }
                renderOption={(option) => (
                  <Box className={classes.optionsContainer}>
                    <Box className={classes.optionAvatar}>
                      <Avatar alt="profile" src={option.imageUrl} />
                    </Box>
                    <Box
                      className={classes.optionNameContainer}
                    >{`${option.firstName} ${option.lastName} `}</Box>
                  </Box>
                )}
                renderInput={(params) => (
                  <TextValidator
                    {...params}
                    label="Doctors"
                    variant="outlined"
                  />
                )}
                renderTags={(tagValue, getTagProps) => {
                  return tagValue.map((option, index) => (
                    <DoctorChip
                      key={index}
                      {...getTagProps({ index })}
                      label={`${option.firstName} ${option.lastName}`}
                      url={option.imageUrl}
                      color={
                        option.userId === getUserInfo().id ? "primary" : ""
                      }
                      deleteIcon={
                        option.userId === getUserInfo().id ? (
                          <CheckIcon />
                        ) : (
                          <RemoveIcon />
                        )
                      }
                    />
                  ));
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <TextValidator
                fullWidth
                label="Description *"
                size="small"
                variant="outlined"
                multiline
                rows={6}
                rowsMax={6}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                validators={["required"]}
                errorMessages={["Description is required"]}
              />
            </Grid>
          </Grid>

          <Box className={classes.addNoteHeadingContainer}>
            <Box>
              <Typography className={classes.addNoteLabel}>Notes</Typography>
            </Box>

            {!showNoteBox && (
              <Box>
                <IconButton
                  color="primary"
                  onClick={() => setShowNoteBox(true)}
                >
                  <AddCircleIcon />
                </IconButton>
              </Box>
            )}
          </Box>

          {showNoteBox && (
            <Box component={Paper} p={3} m={2}>
              <NoteForm
                handleNoteBoxClose={handleNoteBoxClose}
                note={note}
                setNote={setNote}
                noteImages={noteImages}
                setNoteImages={setNoteImages}
                handleNotes={handleNotes}
                showNoteErrorMessage={showNoteErrorMessage}
                setShowNoteErrorMessage={setShowNoteErrorMessage}
                openMedicalUpload={openMedicalUpload}
              />
            </Box>
          )}
          <Box>
            <Timeline>
              {noteItems.map((note, index) => (
                <NoteTimeline key={index} note={note} />
              ))}
            </Timeline>
          </Box>
        </DialogContent>
        <DialogActions classes={{ root: classes.actionsContainer }}>
          <Button
            onClick={handleClose}
            variant="outlined"
            color="primary"
            disableElevation={true}
          >
            Cancel
          </Button>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            disableElevation={true}
          >
            Add
          </Button>
        </DialogActions>
      </ValidatorForm>
    </Dialog>
  );
};

const mapStateToProps = (state) => {
  return {
    athletes: state.athletes.athletes,
    casePriorities: state.cases.casePriorities,
    caseStatus: state.cases.caseStatus,
    doctors: {
      ...state.cases.doctors,
      rows: state.cases.doctors?.rows
        ? state.cases.doctors.rows.filter((doc) => doc.role === "Doctor")
        : [],
    },
    symptomsList: state.cases.symptomsList || [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addCase: (data) => {
      return dispatch(addCaseRequest(data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getCasePriorities: (data) => {
      return dispatch(getCasePrioritiesRequest(data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getCaseStatus: (data) => {
      return dispatch(getCaseStatusRequest(data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getCaseStatusForDoctor: (data) => {
      return dispatch(getCaseStatusForDoctorRequest(data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getDoctorsOfDept: (id) => {
      return dispatch(getDoctorsOfDeptRequest(id)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getSignedUrl: (data) => {
      return dispatch(getSignedUrlRequest(data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    uploadToS3: (url, file) => {
      return dispatch(uploadToS3Request(url, file)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getAllSymptoms: () => {
      return dispatch(getAllSymptomsRequest()).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddCaseDialog);
